import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      if (data?.token) localStorage.setItem("alimi_token", data.token);
      toast.success("Bentornata, Admin");
      nav("/admin");
    } catch (err) {
      toast.error("Accesso negato", { description: err?.response?.data?.detail || "Riprova." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[70vh] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-alimi-surface p-10 border border-alimi-border">
        <span className="overline">Area Riservata</span>
        <h1 className="font-serif text-3xl mt-3">Accedi all'admin</h1>
        <div className="alimi-divider mt-5" />

        <div className="mt-8 space-y-5">
          <div>
            <label className="overline block mb-2">Email</label>
            <input data-testid="admin-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 bg-alimi-bg border border-alimi-border focus:border-alimi-ink outline-none text-sm" />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input data-testid="admin-password" required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-4 py-3 bg-alimi-bg border border-alimi-border focus:border-alimi-ink outline-none text-sm" />
          </div>
          <button data-testid="admin-login-btn" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </div>
      </form>
    </div>
  );
}
